// extracted by mini-css-extract-plugin
export default {"mediumMobile":"(max-width: 480px)","mobile":"(max-width: 360px)","cardGroupWrapper":"CardGroup_cardGroupWrapper__Hdceb"};